<template>
  <q-layout-header>
    <q-toolbar>
      <q-btn
        flat
        round
        small
        icon="menu"
        @click="showLeft = !showLeft"
      >
      </q-btn>
      <q-toolbar-title>
        <strong
          class="toolbar-title clicavel"
          @click="home()"
        >Protocolo</strong>
      </q-toolbar-title>
      <q-chip
        v-if="setQtdeNotificacao() !== 0"
        dense
        color="red-5"
        text-color="white"
        v-show='mostrarNotificacoes'
      >{{ setQtdeNotificacao() }}</q-chip>
      <q-btn-dropdown
        color="primary"
        icon="mail"
        dense
        small
        style="-webkit-box-shadow: 0 0 0 0;"
        v-show='mostrarNotificacoes'
      >
        <q-list
          link
          separator
        >
          <q-item
            v-for="n in arrayNotificacao"
            v-bind:key="n.a"
            @click.native="responderSolicitacao(n.protocoloSolicitacao.id, n.codNotificacaoSolicitacao)"
          >
            <!-- <q-chip
                v-if="n.indAtiva === 'N'"
                dense
                color="green-6"
                class="shadow-1"
                style="margin-right: 20px;"
              >Lido </q-chip>
              <q-chip
                v-else
                dense
                color="warning"
                class="shadow-1"
                style="margin-right: 20px;"
              >Novo</q-chip> -->
            <q-item-main style="width: 100%;">
              <q-item-tile
                label
                v-if="n.indAtiva === 'N'"
              >{{ setDataNotificacao(n.datNotificacao) }} Solicitação Nº: {{ n.protocoloSolicitacao.numSolicitacao }}</q-item-tile>
              <q-item-tile
                label
                v-else
              ><strong>{{ setDataNotificacao(n.datNotificacao) }} Solicitação Nº: {{ n.protocoloSolicitacao.numSolicitacao }}</strong></q-item-tile>
              <q-item-tile
                sublabel
                v-if="n.indAtiva === 'N'"
              >{{ n.protocoloSolicitacao.requerente.nomeDocumento }}</q-item-tile>
              <q-item-tile
                sublabel
                v-else
              ><strong>{{ n.protocoloSolicitacao.requerente.nomeDocumento }}</strong></q-item-tile>
              <q-item-tile
                sublabel
                v-if="n.indAtiva === 'N'"
              >{{ n.desMensagem }}</q-item-tile>
              <q-item-tile
                sublabel
                v-else
              ><strong>{{ n.desMensagem }}</strong></q-item-tile>
            </q-item-main>
            <q-item-side
              right
              dense
              icon="fas fa-external-link-alt"
              color="blue"
            />
          </q-item>
          <q-item v-if="arrayNotificacao.length === 0">
            <q-item-side
              right
              dense
              icon="far fa-smile-beam"
              color="blue-6"
            />
            <q-item-main style="width: 100%;">
              <q-item-tile label> Nenhuma Notificação Web </q-item-tile>
            </q-item-main>
          </q-item>
        </q-list>
      </q-btn-dropdown>
      <q-btn-dropdown
        icon="fas fa-user-alt"
        small
        dense
        color="primary"
        style="-webkit-box-shadow: 0 0 0 0;"
      >
        <q-list
          link
          style="min-width: 100px"
        >
          <q-item
            clickable
            @click.native="abrirCadunico()"
          >
            <q-icon class="icone-menu-suspenso fas fa-home"></q-icon>
            Publicenter
          </q-item>
          <q-item
            clickable
            @click.native="logout()"
          >
            <q-icon class="icone-menu-suspenso fas fa-sign-out-alt"></q-icon>
            Sair
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </q-toolbar>
  </q-layout-header>
</template>

<script>
import utilHttp from 'components/util/utilHttp'
import api from 'components/util/api'
import util from 'components/util/util'
import { login } from 'plugins/login'

export default {
  props: {
    mostrarNotificacoes: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      apiNotificacaoLida: api.NOTIFICACAO_SOLICITACAO_USUARIO_MARCAR_COMO_LIDA,
      apiNotificacaoUsuario: api.NOTIFICACAO_SOLICITACAO_USUARIO,
      apiNotificacao: api.NOTIFICACAO_SOLICITACAO,
      arrayNotificacao: [],
      showLeft: true
    }
  },
  methods: {
    setDataNotificacao (datNotificacao) {
      let data = util.formatarDiaMesAno(datNotificacao)
      let hora = util.formatarHoraMinuto(datNotificacao)
      return data.concat(' às ').concat(hora)
    },
    responderSolicitacao (codSolicitacao, codNotificacaoSolicitacao) {
      var self = this
      let url = api.BUSCAR_PROTOCOLO_SOLICITACAO_MOVIMENTACAO_PELO_COD_SOLICITACAO
      url = url.concat('?codSolicitacao=').concat(codSolicitacao)
      url = url.concat('&status=').concat('PAS')
      utilHttp.httpGet(url, resposta => {
        let paginaStatus = {
          aberturaProcesso: {
            formaSolicitacao: {},
            tipoProcesso: {},
            subassunto: {
              assunto: {}
            },
            roteiro: {
              setor: {
                unidade: {
                  orgao: {}
                }
              }
            },
            requerente: {},
            representante: {},
            justificativa: {},
            responsavel: { usuario: {} },
            documentoNecessario: {},
            aberturaProcessoDocumento: {}
          }
        }
        paginaStatus.protocoloSolicitacaoMovimentacao = resposta.body[0]
        paginaStatus.desabilitarEdicao = false
        paginaStatus.operacao = {
          descricao: 'Gerenciar Solicitação de Abertura',
          icone: 'fas fa-reply'
        }
        paginaStatus.caminhoMigalha = []
        paginaStatus.caminhoMigalha.push(
          {
            icone: 'fas fa-folder-open',
            descricao: 'Gestão de Solicitação de Abertura',
            rotaNome: 'solicitacaoAberturaPesquisa'
          }
        )
        self.marcarNotificacaoComoLida(paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.id, codNotificacaoSolicitacao)
        self.$router.push({
          name: 'solicitacaoAbertura',
          params: {
            paginaStatus: paginaStatus
          }
        })
        // window.open('/#/privado/gestaoSolicitacaoAbertura/cadastrar')
        // self.$router.go({name: 'solicitacaoAbertura'})
      })
    },
    setCorMensagemNotificacao (mensagem) {
      if (mensagem.toString().includes('Nova')) {
        return 'green'
      } else {
        return 'orange'
      }
    },
    setQtdeNotificacao () {
      let qtde = 0
      this.arrayNotificacao.forEach(n => {
        if (n.indAtiva === 'S') {
          qtde = qtde + 1
        }
      })
      return qtde
    },
    verificarSolicitacaoWeb () {
      let url = api.BUSCAR_TODAS_NOTIFICACAO_SOLICITACAO
      url = url.concat('?codUsuario=').concat(this.$login.getCodUsuario())
      utilHttp.httpGet(url, resposta => {
        this.arrayNotificacao = resposta.body
      })
      // setTimeout(() => this.verificarSolicitacaoWeb(), 100000)
    },
    marcarNotificacaoComoLida (codProtocoloSolicitacao, codNotificacaoSolicitacao) {
      let url = this.apiNotificacaoLida
      url = url.concat('?codProtocoloSolicitacao=').concat(codProtocoloSolicitacao)
      url = url.concat('&codUsuario=').concat(this.$login.getCodUsuario())
      utilHttp.httpGet(url, resposta => {
        this.verificarSolicitacaoWeb()
      })
      utilHttp.httpDeletePorID(`${this.apiNotificacao}/${codNotificacaoSolicitacao}`, (resposta) => {
        console.log('Notificação excluida')
      })
    },
    home () {
      this.$router.push('/privado/index')
    },
    logout () {
      this.$q.dialog({
        title: 'SAINDO',
        message: 'Deseja realmente sair do sistema?',
        cancel: true
      }).then(() => {
        // Picked "OK"
        login.sair()
      }).catch(() => {
        // Picked "Cancel" or dismissed
      })
    },
    abrirCadunico () {
      this.$login.abrirCadUnico()
    }
  },
  mounted () {
    this.verificarSolicitacaoWeb()
  }
}
</script>
